import React, {useState} from 'react';
import UploadGalleryModal from '../../../../components/uploadgallery/UploadGalleryModal';
import reviewBuilderUploadsApi from '../../../../components/uploadgallery/reviewBuilderGalleryApi';
import YelpCategorySelector from "../../../../services/categories/YelpCategorySelector";

function BulkLocationEditorYelp ({locationPatch, updateCovidBannerMessage, updateImages, updateCategories, yelpCategoriesStore}) {

  const [imageSelectorOpen, setImageSelectorOpen] = useState(false);

  const [yelpCategoriesErrorMessage, setYelpCategoriesErrorMessage] = useState(null);

  const addImage = (imageUrl) => {
    setImageSelectorOpen(false);
    updateImages(locationPatch.yelpListingManagementSpecs.images.concat([{url: imageUrl, caption: undefined}]))
  };

  const removeImage = (imageUrl) => {
    updateImages(locationPatch.yelpListingManagementSpecs.images.filter(image => image.url !== imageUrl))
  };

  const yelpCovidBannerMessageChange = (e) => {
    const message = e.target.value;
    if (message === "") {
      updateCovidBannerMessage(null)
    } else {
      updateCovidBannerMessage(message)
    }
  };

  const handleYelpCategoriesUpdate = (selected) => {
    if (selected.length <= 3) {
      updateCategories(selected);
      setYelpCategoriesErrorMessage(null)
    } else {
      setYelpCategoriesErrorMessage("Select up to 3 Yelp categories.")
    }
  };

  const handleImageCaptionChange = (imageIndex) => (e) => {
    const caption = e.target.value === "" ? undefined : e.target.value;

    const updatedImages = locationPatch.yelpListingManagementSpecs.images.map((image, index) => {
      return {
        ...image,
        caption: (index === imageIndex ? caption : image.caption)
      };
    });

    updateImages(updatedImages)
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Yelp Categories</h5>
    <div>Maximum of 3 categories per listing. Categories can be added to locations without any existing categories. Changes to categories must go through Yelp directly, in accordance with their policy. Please log in to your Yelp account or contact Yelp Support to make updates to your existing categories.</div>
    <div className="row card-spacer-top">
      <div className="col-12 col-sm-12">
        <YelpCategorySelector
          multi={true}
          selected={locationPatch.yelpListingManagementSpecs.categories}
          categoriesStore={yelpCategoriesStore}
          onSelect={handleYelpCategoriesUpdate}
        />
        {yelpCategoriesErrorMessage ? <div className="invalid-feedback" style={{"display": "block"}}>{yelpCategoriesErrorMessage}</div> : <div className="invalid-feedback" style={{"opacity": "0", "display": "block"}}>line spacer</div>}
      </div>
    </div>


    <h5 className="content-spacer-top">Yelp Images</h5>
    <div>There is a maximum of 25 photos, including those already saved to locations. When the maximum of 25 is exceeded, the most recently added ones will be kept and the oldest ones will be discarded from each location.</div>
    <div className="row card-spacer-top">
      {locationPatch.yelpListingManagementSpecs.images.map((image, imageIndex) => {
        return <div className="col-4 col-sm-4"><div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <img src={image.url} style={{"height": "100px"}} />
          </div>
          <div>
            <input type="text" className="form-control" style={{"marginTop": "10px"}} maxLength="128" placeholder="Caption" value={image.caption} onChange={handleImageCaptionChange(imageIndex)} />
          </div>
          <div className="text-center" style={{"marginTop": "3px"}}>
            <a onClick={() => removeImage(image.url)} href="javascript:void(0)" style={{textDecoration: 'underline'}}>Remove</a>
          </div>
        </div>
        </div>
      })}
      {locationPatch.yelpListingManagementSpecs.images.length < 25 && <div className="col-4 col-sm-4">
        <div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <div style={{"height": "130px", "opacity": "0"}}/>{/* Spacer to match height of uploaded images */}
            <button type="button" className="btn btn-secondary" onClick={() => setImageSelectorOpen(true)}>
              <i className="far fa-plus" />
            </button>
          </div>
        </div>
      </div>}
    </div>
    {
      imageSelectorOpen && 
      <UploadGalleryModal 
        title="Select or Upload a General Image"
        modalToggle={setImageSelectorOpen} 
        imageSelectedCallback={(image) => addImage(image.url)} 
        minImageWidthPixels={250} 
        minImageHeightPixels={250} 
        maxImageWidthPixels={5000} 
        maxImageHeightPixels={5000}
        galleryApi={reviewBuilderUploadsApi}
      />
    }

    <h5 className="content-spacer-top">COVID-19 Banner Message</h5>
    <div> A COVID related message that's relevant and useful for consumers. Phone numbers, websites link, social media links that represent the business may be included. This could also be used to denote if the location is still offering virtual services, delivery, or takeout etc. Max 1500 characters.</div>
    <textarea
      id="yelpCovidBannerMessage"
      placeholder="COVID-19 Banner Message"
      maxLength={1500}
      value={locationPatch.yelpListingManagementSpecs.covidBannerMessage}
      onChange={yelpCovidBannerMessageChange}
      className="form-control text-input content-spacer-top"
    />
    <small className="pull-right ng-binding">{!!locationPatch.yelpListingManagementSpecs.covidBannerMessage ? <span>{locationPatch.yelpListingManagementSpecs.covidBannerMessage.length}</span> : <span style={{"display": "block", opacity: "0"}}>line spacer</span>}</small>
  </div>
}

export default BulkLocationEditorYelp;